import { BrowserRouter as Router, Routes, Route } from 'react-router';

import AdminRoute from './components/admin/AdminRoute';
import Layout from './layouts/RootLayout';
import AdminPage from './pages/admin/AdminPage';
import AuditTrailPage from './pages/audit-trail/AuditTrailPage';
import ControlDetailPage from './pages/controls/ControlDetailPage';
import ControlListPage from './pages/controls/ControlListPage';
import ControlProgressPage from './pages/controls/ControlProgressPage';
import ControlReleasePage from './pages/controls/ControlReleasePage';
import DocumentDetailPage from './pages/documents/DocumentDetailPage';
import DocumentListPage from './pages/documents/DocumentListPage';
import DocumentPDFViewPage from './pages/documents/DocumentPDFViewPage';
import DocumentReleasePage from './pages/documents/DocumentReleasePage';
import DocumentTempPage from './pages/documents/DocumentTempPage';
import QualityDetailPage from './pages/qualities/QualityDetailPage';
import QualityListPage from './pages/qualities/QualityListPage';
import QualityProgressionPage from './pages/qualities/QualityProgressionPage';
import QualityReleasePage from './pages/qualities/QualityReleasePage';
import TemplateDetailPage from './pages/templates/TemplateDetailPage';
import TemplateListPage from './pages/templates/TemplateListPage';
import TemplatePreviewPage from './pages/templates/TemplatePreviewPage';
import WelcomePage from './pages/WelcomePage';
import './styles/App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Layout>
          <Routes>
            <Route path="/" element={<WelcomePage />} />
            <Route path="/controls" element={<ControlListPage />} />
            <Route path="/control/:id" element={<ControlDetailPage />} />
            <Route path="/control/:id/edit" element={<ControlDetailPage />} />
            <Route path="/control/:id/release" element={<ControlReleasePage />} />
            <Route path="/control/new" element={<ControlDetailPage />} />
            <Route
              path="/control/:id/progress"
              element={<ControlProgressPage />}
            />
            <Route path="/documents" element={<DocumentListPage />} />
            <Route
              path="/document/:id"
              element={<DocumentDetailPage key="view" />}
            />
            <Route
              path="/document/:id/edit"
              element={<DocumentDetailPage key="edit" />}
            />
            <Route path="/document/:id/release" element={<DocumentReleasePage />} />
            <Route path="/document/new" element={<DocumentTempPage />} />
            <Route
              path="/document/new/:templateId"
              element={<DocumentDetailPage />}
            />
            <Route path="/document/pdf/:id" element={<DocumentPDFViewPage />} />
            <Route path="/qualities" element={<QualityListPage />} />
            <Route path="/quality/:id" element={<QualityDetailPage />} />
            <Route path="/quality/:id/edit" element={<QualityDetailPage />} />
            <Route path="/quality/:id/release" element={<QualityReleasePage />} />
            <Route path="/quality/:id/progression" element={<QualityProgressionPage />} />
            <Route path="/quality/new" element={<QualityDetailPage />} />
            <Route path="/templates" element={<TemplateListPage />} />
            <Route path="/template/:id" element={<TemplateDetailPage />} />
            <Route path="/template/:id/preview" element={<TemplatePreviewPage />} />
            <Route path="/admin/users" element={<AdminRoute><AdminPage /></AdminRoute>} />
            <Route path="/audit-trail" element={<AuditTrailPage />} />
          </Routes>
        </Layout>
      </div>
    </Router>
  );
}

export default App;
